import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { MonCompteState, state } from '@/modules/MonCompte/store/state';
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

const module: Module<MonCompteState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { MonCompteState };

